<template>
  <div class="columns" style="margin-top: -0.2rem;">
    <div class="column has-text-centered">
      {{
        moment
          .utc(statusHistory.deliveryCreatedAt)
          .add(preferences.timezone, "h")
          .format("DD/MM/YY HH:mm:ss")
      }}
    </div>

    <div class="column has-text-centered">
      {{
        statusHistory.accessedByCourierAt
          ? moment
              .utc(statusHistory.accessedByCourierAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : statusHistory.deliveryConfirmedAt
          ? moment
              .utc(statusHistory.deliveryConfirmedAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : statusHistory.waitingPickUpAt
          ? moment
              .utc(statusHistory.waitingPickUpAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : "-"
      }}
    </div>

    <div class="column has-text-centered">
      {{
        statusHistory.accessedByClientAt
          ? moment
              .utc(statusHistory.accessedByClientAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : statusHistory.pickUpConfirmedAt
          ? moment
              .utc(statusHistory.pickUpConfirmedAt)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          : "-"
      }}
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["statusHistory"],

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>
